// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec5cdb54","732":"8a9b4935","977":"6f08b440"}[chunkId] + ".chunk.js";
};